export const activeInsurances = [
  'HOGAR',
  'PERTENENCIAS PROTEGIDAS',
  'TECNO',
  'MOVILIDAD',
  'VIDA INDIVIDUAL',
  'ACCIDENTES PERSONALES',
  'ROBO EN CAJERO AUTOMATICO',
  'MASCOTA',
  'INTEGRAL DE COMERCIO',
  'AUTOMOTOR',
];
